import applications from "./applications.vue";
export default applications;